module.exports = __webpack_public_path__ + "images/ai_recommendations/globe-28fcbd40b0b8d0ca9f95f995832bcb14.svg";